import { IGroup } from '@interfaces/IGroup';

export interface IGroupFormErrors {
  [key: string]: string[];
}

export interface IGroupsState {
  errors: {
    createGroup: IGroupFormErrors;
    editGroup?: IGroupFormErrors;
    getGroups?: IGroupFormErrors;
  };
  groups: {
    [key: number]: IGroup[];
  };
  groupsArray: IGroup[];
  loading?: {
    allGroups?: boolean;
  };
  selectedGroup: IGroup | null;
}

export const initialGroupsState: IGroupsState = {
  errors: {
    createGroup: {},
    getGroups: {},
  },
  groupsArray: [],
  groups: {},
  loading: {
    allGroups: true,
  },
  selectedGroup: null,
};
